import { INTEGRATION_STATUS } from "app/pages/sales-intelligence/pages/management/constants/constants";
import type {
    IntegrationStatus,
    IntegrationStatusResponse,
} from "app/pages/sales-intelligence/sub-modules/management/components/types";
import type { CrmImportSetting } from "app/pages/sales-intelligence/sub-modules/management/types";
import { getActiveImportSettings } from "app/pages/sales-intelligence/sub-modules/management/utils/utils";

export interface ExtractedCRMData {
    isIntegrated: boolean;
    isExclusionOn: boolean;
    isExportAccountsOn: boolean;
    isExportContactsOn: boolean;
    isExportLeadsOn: boolean;
    activeImportSettings: CrmImportSetting[];
    crmConnectionStatus: IntegrationStatus | undefined;
}

const extractCRMData = (crmData: IntegrationStatusResponse): ExtractedCRMData => {
    const { crmConnectionStatus, companyAsLeadExportClaimEnabled } = crmData;

    return {
        isIntegrated: crmConnectionStatus.syncStatus !== INTEGRATION_STATUS.NotIntegrated,
        isExclusionOn: crmConnectionStatus.isLeadsFilterEnabled,
        isExportAccountsOn: crmConnectionStatus.isExportEnabled,
        isExportContactsOn: crmConnectionStatus.isContactExportEnabled,
        isExportLeadsOn: companyAsLeadExportClaimEnabled
            ? !!crmConnectionStatus.isCompanyAsLeadExportEnabled
            : !!crmConnectionStatus.isLeadsExportEnabled,
        activeImportSettings: getActiveImportSettings(
            crmConnectionStatus.isCrmListEnabled,
            crmConnectionStatus.isLeadsFilterEnabled,
            crmConnectionStatus.isCrmLabelsEnabled,
        ),
        crmConnectionStatus,
    };
};

export default extractCRMData;
